
export const turfUsername = ['backyard-arena-turf','strikerz-turf'];

export const dayMapping: any = {
    D1: 'Monday',
    D2: 'Tuesday',
    D3: 'Wednesday',
    D4: 'Thursday',
    D5: 'Friday',
    D6: 'Saturday',
    D7: 'Sunday',
  };

 export const dayOrder: Record<string, number> = {
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
    Sunday: 7,
  };


  // export const unavailableTurf= ['buddys-astro-turf','mp-09-turf-and-cafe','the-offside-sports-turf','sp-turf-and-cafe'];
  
export const facilitiesConfig = {
  isCovered: "Rain covered",
  hasCafe: "Cafeteria present",
  providesEquipment: "Provides playing equipment",
  hasParking: "Parking available",
  opens24x7:"24/7 Available",
};